import React from 'react';
import './offers.scss';

import OfferDetailBuy from './offerDetailBuy.js';
import OfferDetailSale from './offerDetailSale.js';
import OfferDetailCustomer from './offerDetailCustomer.js';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import { useState, useEffect, useCallback} from "react";
import ScrollView from "devextreme-react/scroll-view";

import DataGrid, {
    Column,
    Button,
    Editing,
    Selection,
    Lookup, 
    Form as GridForm
} from 'devextreme-react/data-grid';

import { createStore } from 'devextreme-aspnet-data';
import {
    Form,
    SimpleItem,
    //EmptyItem,
    GroupItem,
    CustomRule,
    RequiredRule
    //Tab,
    //TabPanelOptions
} from 'devextreme-react/form';

import {Popup as ToolbarPopup} from 'devextreme-react/popup';
import notify from 'devextreme/ui/notify';
//import { Button } from 'devextreme-react/button';
import {Button as ToolbarButton} from 'devextreme-react/button';
import Toolbar from 'devextreme-react/toolbar';
//import { formatNumber } from "devextreme/localization";

import {Logout, IsRole_Admin, IsRole_SalesManager, statoNotificaAttivitaOptions,tipoAttivitaOptions,SevenDaysFormatted, TodayFormatted, DateFormatted} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

const debug = process.env.ENTITY_DEBUG;

export default function OfferDetail(props) {

    var newPA;
    var newPV;
    var newDelta;
    var newMargine;
    //const formRef = useRef(null);

    var attivitaDataGridRef = React.createRef();

    //const myForm = useRef(null);
    var myForm = React.createRef();

    const [detail, setDetail] = useState({});
    const [collaboratori, setCollaboratori] = useState({});
    const [isPopupVisible2, setPopupVisibility2] = useState(false);
    const togglePopup2 = () => {
      setPopupVisibility2(!isPopupVisible2);
    };

    const [isPopupVisible3, setPopupVisibility3] = useState(false);
    const togglePopup3 = () => {
      setPopupVisibility3(!isPopupVisible3);
    };

    const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaCommenti'
    const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaAttivita'
    const { user } = useAuth(); 

    if (!user) 
      Logout();

    const isSalesManager=IsRole_SalesManager();
    const isAdmin=IsRole_Admin();

    const remoteDataSource2 = createStore({
    
        key: 'id',
        loadUrl: serviceUrl2 + '/FindByOfferta/' + props.data.key,
        onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
        },  
        insertUrl: serviceUrl2 + '/InsertAction',
        updateUrl:serviceUrl2 + '/UpdateAction',
        deleteUrl: serviceUrl2 + '/DeleteAction'
        
    });

    const remoteDataSource3 = createStore({
    
        key: 'id',
        loadUrl: serviceUrl3 + '/FindByOfferta/' + props.data.key,
        onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
        },  
        insertUrl: serviceUrl3 + '/InsertAction',
        updateUrl:serviceUrl3 + '/UpdateAction',
        deleteUrl: serviceUrl3 + '/DeleteAction'
        
    });

    useEffect(() => {
    
        const fetchData = async () => {
    
          const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
          var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";
          try {

            const requestOptions = {
              headers: {
                Authorization: `Bearer ${user.token}`
              }
            };
          
            const response3 = await fetch(newUrl3,requestOptions);
            const json3 = await response3.json();
            if (debug === 1)
              console.log(json3);
            setCollaboratori(json3);
        } catch (error) {
            console.log("error", error);
          }
    };
    
        fetchData();
      }, []);

    function onRowInserting(e) {
        e.data.offertaId = props.data.key;
        // if (e.data.createBy !== undefined)
        //     e.data.createBy = user.name;
    };


    const getDefaultData = async () => {
        const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaAttivita';
        var url = serviceUrl + "/GetDefaultValues/" + props.data.key + "/" + user.userId;
        const requestOptions = {
            headers: {
                Authorization: `Bearer ${user.token}`
            }
        };
    
        try {
            //console.log("Fetching data from:", url);
            const response = await fetch(url, requestOptions);
    
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
            console.log("Fetched data:", data);
            return data;
        } catch (error) {
            console.error("Error fetching default data:", error);
            return null;
        }
    };

    const handleInitNewRow = (e) => {
        e.data.dataAttivita = new Date();
        e.data.completata = false;
        e.data.createBy = user.name;
    
        e.promise = getDefaultData().then((defaultData) => {
            //console.log("Default data in handleInitNewRow:", defaultData);
    
            if (defaultData && typeof defaultData === "object") {
                e.data.collaboratoreId = defaultData.collaboratoreId || null;
                e.data.riferimentoCliente = defaultData.riferimentoCliente || null;
            } else {
                console.warn("Warning: Default data is null or undefined");
            }
        }).catch((error) => {
            console.error("Errore durante l'inizializzazione della riga:", error);
        });
    };
    

    const renderContent2 = () =>  {
        return (
        <div>
            <div className="offer-title-small" align="left" > 
                <h3>Offerta n° {detail.numeroDoc} del {detail.strDataDoc} - {props.data.data.cliente}</h3>
            </div>
            <DataGrid id="grid-subcontainer"
                dataSource={remoteDataSource2}
                onRowInserting={onRowInserting}
                showBorders={true}
                dateSerializationFormat= {'yyyy-MM-dd'}
            >
            <Selection mode="single" />
            <Toolbar>
                <Item name="addRowButton"  />
            </Toolbar>
            <Editing
                mode="row"
                allowUpdating={false}
                allowAdding={false}
                allowDeleting={false}
                useIcons={true}
            >
            </Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="riferimentoDoc" width={140}/>
            <Column dataField="riferimentoPagina" caption = "Rif. Pagina" width={80}/>
            <Column dataField="riferimentoCapitolo" caption = "Rif. Capitolo" width={80}/>
            <Column dataField="commento" />
            </DataGrid>
        </div>            
        )
    }

    const validateCompletata = (e) => {

        var isCompletata = e.value;
        console.log("isCompletata:" + isCompletata);
        var scadenza = e.data.dataScadenza;
        if(scadenza === undefined )
            return true;
        console.log("scadenza:" + scadenza);
        if (scadenza !== null && isCompletata === false) 
          return false;
        else
          return true;
    };

    const onCellPreparedGrid = (e) => {
    
        if (e.rowType === "data") {
            if (e.column.dataField === "dataAttivita") { 
                var isCompletata = e.data.completata;
                var dataAttivita = e.data.dataAttivita;

                if (isCompletata)
                {
                    e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
                }
                else if (dataAttivita < TodayFormatted())
                {
                    e.cellElement.style.cssText = "color: red; font-weight: bold";
                }
                else if ((dataAttivita < SevenDaysFormatted()) &&  (dataAttivita >= TodayFormatted()) )
                {
                    e.cellElement.style.cssText = "color: orange; font-weight: bold";
                }
            
            }
        }

    }

    const showEditButton = useCallback((e) => {
        if (isSalesManager || isAdmin)
            return true
        else
        {
            //console.log("SHOW " + e.row.data.completata)
            return e.row.data.completata === false;
        }
    }, []);

    const renderContent3 = () =>  {

         const onEditorPreparing = (e) => { 
            if (e.parentType == 'dataRow' && e.dataField == 'descrizione') {  
                e.editorOptions.maxLength = 400;  
            }  
        } 

        return (
             <ScrollView height="100%">
            <div style={{ padding: "10px" }}>
        <div>
            <div className="offer-title-small" align="left" > 
                <h3>Offerta n° {detail.numeroDoc} del {detail.strDataDoc} - {props.data.data.cliente}</h3>
            </div>
                <DataGrid id="grid-subcontainer"
                    dataSource={remoteDataSource3}
                    onRowInserting={onRowInserting}
                    onInitNewRow={handleInitNewRow}
                    showBorders={true}
                    onCellPrepared={onCellPreparedGrid}
                    dateSerializationFormat= {'yyyy-MM-dd'}
                    ref={ref => attivitaDataGridRef = ref}
                    onEditorPreparing={onEditorPreparing}
                >
                <Selection mode="single" />
                <Toolbar>
                    <Item name="addRowButton"  />
                </Toolbar>
                <Editing
                    mode="form"
                    allowUpdating={true}
                    allowAdding={true}
                    allowDeleting={true}
                    useIcons={true}
                >
                <GridForm>
                    <SimpleItem dataField="dataAttivita" />
                    <SimpleItem dataField="collaboratoreId" />
                    <SimpleItem dataField="tipoAttivitaId" />
                    <SimpleItem dataField="riferimentoCliente" />
                    <SimpleItem dataField="descrizione" colSpan={2} />
                    <SimpleItem dataField="dataScadenza" />
                    <SimpleItem dataField="completata" editorType='dxCheckBox'></SimpleItem>
                    <SimpleItem dataField="statoNotificaId" />
                    <SimpleItem dataField="statoNotifica2Id" />
                </GridForm>

            </Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="dataAttivita" dataType="date" format= {'dd/MM/yyyy'} caption="Data attività" width={120} >
                <RequiredRule/>
            </Column>
            <Column dataField="collaboratoreId" caption="Assegnatata a" width={140} >
                <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
                <RequiredRule/>
            </Column>
            <Column dataField="tipoAttivitaId" caption="Tipo Attività" visible={false}>
                <Lookup dataSource={tipoAttivitaOptions} displayExpr="desc" valueExpr="id" />
                <RequiredRule/>
            </Column>
            <Column dataField="descrizione" caption = "Attività">
                <RequiredRule/>
            </Column>
            <Column dataField="riferimentoCliente" caption = "Rif. Cliente" width={120} visible={false}/>
            <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} caption="Follow up" width={120}/>
            <Column dataField="completata" width={80} caption="Compl.">
                <CustomRule type="custom" message={"L'attività deve essere completata se è previsto un Follow-up"} validationCallback={validateCompletata} />
            </Column>
            <Column dataField="statoNotificaId" caption="Notifica al DC" visible={false} >
                <Lookup dataSource={statoNotificaAttivitaOptions} displayExpr="desc" valueExpr="id" />
            </Column>
             <Column dataField="statoNotifica2Id" caption="Notifica all'assegnatario" visible={false} >
                <Lookup dataSource={statoNotificaAttivitaOptions} displayExpr="desc" valueExpr="id" />
            </Column>
            <Column dataField="createBy" visible={false}/>
            <Column type="buttons">
                <Button name="edit" visible={showEditButton} />
                <Button name="delete" visible={showEditButton}/>
            </Column>
            </DataGrid>
        </div>   
              </div>
        </ScrollView> 
        )
      }


    function renderOfferBuyTab() {
        //console.log("K: " +props.data.key);
        //return <OfferDetailBuy myKey = {props.data.key} change = {handleState}/>;
        return <OfferDetailBuy myKey = {props.data.key} status = {detail.statoId} />;
    }
  
    function renderOfferSaleTab() {
        //console.log("K: " +props.data.key);
        return <OfferDetailSale myKey = {props.data.key} status = {detail.statoId}/>;
    }

    function renderOfferCustomerTab() {
        //console.log("K: " +props.data.key);
        return <OfferDetailCustomer myKey = {props.data.key} status = {detail.statoId}/>;
    }

    useEffect(() => {

        const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Offerte';
        var newUrl =  newServiceUrl + "/GetAction/" + props.data.key;

        const requestOptions = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${user.token}`
            }
          };

        const fetchData = async () => {
            try {

                const response = await fetch(newUrl, requestOptions);
                const json = await response.json();
                console.log(json);
                setDetail(json);

            } catch (error) {
                console.log("error", error);
            }
        };
        fetchData();
    }, []);

    const editorOptions = { readonly: true, format: '#,##0.00'};
    const editorOptionsPerc = { readonly: true, format: "#0.00 '%'"};

    //function reloadData() {
    async function reloadData() {
        const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Offerte';
        var url =  newServiceUrl + "/GetAction/" + props.data.key;
    
        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };
    
        return fetch(url, requestOptions)
        .then(response => {
          if(response.ok) return response.json();
          //Global.CheckResponseAuth(response);
          return null;
        })
        .then(data => { 
            console.log(data)
            //setNewDetail(data);
            console.log('NUOVO PA TOTALE FETCH' +data.paTotale);
            newPA = data.paTotale;
            newPV = data.pvTotale;
            newDelta = data.delta;
            newMargine = data.margine;
            ;
          
        })
        .catch(error => { notify(error, 'error', 5000); }); 



    };


    async function showMessage() {
        //notify("The button was clicked");
        await reloadData();
        console.log('NUOVO PA TOTALE ' + newPA);
        myForm.instance().updateData('paTotale', newPA)
        myForm.instance().updateData('pvTotale', newPV)
        myForm.instance().updateData('delta', newDelta)
        myForm.instance().updateData('margine', newMargine)
        myForm.instance().repaint();
    }

    const onTabSelectionChanged = useCallback((e) => {
        //notify("The button was clicked");
        ;
    }, []);

    const infoHint= "Creata da " + detail.createBy + " il " + detail.strCreateDate + "\n" + "Modificata da " + detail.updateBy + " il " + detail.strUpdateDate ;

    const numberFormatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    //console.log("FORMAT: " + props.data.data.imponibile, typeof props.data.data.imponibile);
    const paTotaleFormat = numberFormatter.format(props.data.data.paTotale);
    const imponibileFormat = numberFormatter.format(props.data.data.imponibile);
    const pvTotaleFormat = numberFormatter.format(props.data.data.pvTotale);
    const deltaFormat = numberFormatter.format(props.data.data.delta);
    const margineFormat = numberFormatter.format(props.data.data.margine);
    const commissioneFormat = numberFormatter.format(props.data.data.importoCommissione);
    const percCommissioneFormat = numberFormatter.format(props.data.data.percCommissione);

    return (
    
    
         <div>
            <div className="offer-title" align="left" > 
                <h2>Offerta n° {props.data.data.numeroDoc} del {props.data.data.strDataDoc} - {props.data.data.cliente}</h2>
                
            </div>

            <div className="offer-button-refresh" align="right"> 
               
                <Toolbar>
                    <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                        icon='clock'
                        hint='Attività'
                        onClick={togglePopup3}
                    />
                    </Item>
                    <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                        icon='verticalaligncenter'
                        hint='Deviazioni/Precisazioni'
                        onClick={togglePopup2}
                    />
                    </Item>
                    <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                        icon='refresh'
                        hint='Aggiorna'
                        onClick={showMessage} 
                    />
                    </Item>
                    <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                        icon='info'
                        hint= {infoHint}
                    />
                    </Item>
                    
                </Toolbar>
            </div>


        <div>
           
             <div>
                <div className={'myrecap-container-small'}>
                    <div className={'myrecap-data-small'}>Pa Totale:&nbsp;<b> {paTotaleFormat} </b></div>
                    <div className={'myrecap-data-small'}>Pv Totale:&nbsp;<b>{pvTotaleFormat}</b></div>
                    <div className={'myrecap-data-small'}>Delta:&nbsp;<b>{deltaFormat}</b></div>
                    <div className={'myrecap-data-small'}>Margine:&nbsp;<b>{margineFormat}%</b></div>
                    <div className={'myrecap-data-small'}>Commissione:&nbsp;<b> {commissioneFormat} </b></div>
                 
                </div>
            </div>
           
        </div>
        <div>
      
            <TabPanel    
                onSelectionChanged={onTabSelectionChanged}
            >
                <Item title="Acquisto" render={renderOfferBuyTab} />
                <Item title="Vendita" render={renderOfferSaleTab} />
                <Item title="Cliente" render={renderOfferCustomerTab} />
            </TabPanel>
             
        </div>  

        <div>
            <ToolbarPopup
                width={1080}
                height={640} 
                showTitle={true}
                title="Deviazioni/Precisazioni"
                visible={isPopupVisible2}
                hideOnOutsideClick={true}
                onHiding={togglePopup2}
                contentRender={renderContent2}
            > 
            </ToolbarPopup> 
        </div>

        <div>
            <ToolbarPopup
                width={1080}
                height={640} 
                showTitle={true}
                title="Attività"
                visible={isPopupVisible3}
                hideOnOutsideClick={true}
                onHiding={togglePopup3}
                contentRender={renderContent3}
            > 
            </ToolbarPopup> 
        </div>
    </div> 
)};